import { Button, CircularProgress, FormGroup, Grid, Radio, TextField, Typography } from "@mui/material";
import AdayContainer from "./AdayGeneral";

import useGlobal from "../../../util/Global";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CustomTextField } from "../../../components/yupComponent/CustomTextField";
import { CustomRadioGroup } from "../../../components/yupComponent/CustomRadioGroup";
import StorageUtils from "../../../ui/StorageUtils";
import AdayIdxRootservice from "../../../service/Ebasvuru/AdayDomain/AdayIdxRootService";
import Accountservice from "../../../service/Core/AccountService";
import { useEffect, useState } from "react";
import EbasvuruTenantservice from "../../../service/Ebasvuru/EbasvuruTenantService";
import ApiUrl from "../../../service/ApiUrl";
import useMessage from "../../../util/useMessagev2";
import useNavigator from "../../../util/useNavigator";
import { getIPAddress, getLocalIP } from "../../../util/GeneralFunc";
import { CustomDateField } from "../../../components/yupComponent/CustomDateField";

const AdayKimlikBilgisi = () => {

    const adayUser = StorageUtils.get("aday");
    const { t, g } = useGlobal();
    const { goTo } = useNavigator();
    const [token, setToken] = useState(null);
    const message = useMessage();
    const [adayIp, setIp] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const fields = [
        {
            name: "ad",
            label: t('col.ad'),
            type: "text",
            validation: yup.string()
                .required(`${t('col.adi')} ${t('col.mandatory')}`),
            required: true
        },
        {
            name: "soyad",
            label: t('col.soyadi'),
            type: "text",
            validation: yup.string().required(`${t('col.adiSoyadi')} ${t('col.mandatory')}`),
            required: true
        },
        {
            name: "tcKimlikNo",
            label: t('col.tCKimlikNo'),
            type: "text",
            validation: yup.string()
                .matches(/\d{11}/, t("error.invalidTCKN"))
                .required(`${t('col.tCKimlikNo')} ${t('col.mandatory')}`),
            required: true
        },
        {
            name: "dogumTarihi",
            label: t('col.birthdate'),
            type: "date",
            validation: yup.date()
                .typeError(t('error.invalidDate'))
                .required(`${t('col.birthdate')} ${t('col.mandatory')}`),
            required: true
        },
        {
            name: "cepTel",
            label: t('title.cepTelefon'),
            type: "text",
            disabled: true
        },
        {
            name: "email",
            label: t('col.emailAdres'),
            type: "email",
            validation: yup.string()
                .email(t('error.invalidEmail'))
                .required(`${t('col.emailAdres')} ${t('col.mandatory')}`),
            required: true
        },
    ];

    const schema = yup.object().shape({
        ...Object.fromEntries(fields.map(field => [field.name, field.validation])),
        consent: yup.string().required(t('error.consentRequired')),
    });


    const { register, handleSubmit, control, formState: { errors, isValid } } = useForm({
        resolver: yupResolver(schema),
        mode: "all",
        defaultValues: {
            cepTel: adayUser.cepTel,
            dogumTarihi: null
        }
    });

    const SendSMS = async (aday) => {

        var res = await EbasvuruTenantservice.SendSMS(
            {
                aday: {
                    adayId: aday.id,
                    cepTel: aday.cepTel,
                    tCKN: aday.tcKimlikNo,
                    ad: aday.ad,
                    Soyad: aday.soyad,

                },
                tel: aday.cepTel,
                adayIPAdresi: adayIp,
                iletisimSenaryosu: 1, // LoginOnayKoduSMS
            });

        if (res && res.isSuccess) {
            goTo({ page: 'adayonaykodu' });
        } else {
            message.error(t('message.FailedToSendSMSToAday'));
        }

        const adayUser = StorageUtils.get("aday");

        StorageUtils.save("aday",
            {
                cepTel: aday.cepTel,
                adayIp: adayIp,
                sendTime: Date.now(),
                ...adayUser,
                ...aday
            }
        );
    }


    const onSubmit = async (data) => {

        console.log(data);


        setIsSubmitting(true);
        try {
            let res = await EbasvuruTenantservice.basePost({
                endPoint: ApiUrl.publicEndpoint.AdyRegister,
                data: data
            });

            if (res && res.isSuccess) {
                await SendSMS(res.resultObject);
            } else {
                message.error(t(res.message));
            }

            console.log(data);
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        let isMounted = true;
        if (adayUser) {
            Accountservice.loginAsAday({ tenant: adayUser.tenantKey })
                .then((res) => {
                    if (res?.token) {
                        EbasvuruTenantservice.setToken(res.token);
                        setToken(res.token);
                    }
                })
                .catch((err) => console.error("Login failed:", err));

            getLocalIP().then((ip) => {
                if (isMounted) setIp(ip);
            });

        }
        return () => {
            isMounted = false; // Cleanup on unmount
        };
    }, []);


    return <AdayContainer isLoading={false}>
        <Grid container spacing={4} maxWidth="90%" sx={{ alignItems: "center", mt: 1 }}>
            {/* Left Side - Image */}
            <Grid item xs={12} md={6} sx={{ textAlign: "center" }} >
                <img
                    src="/sec-login-idari.png" // Replace with actual image path
                    alt={t("title.SecuritasTeam")}
                    style={{
                        width: "30vw",
                        height: 'auto',

                    }}
                />

                <Typography display={"block"} sx={{ color: "text.dark", pt: 2, fontSize: '1.9rem' }}>
                    {t('title.makeWorldSafer')}
                </Typography>

                <Typography display={"block"} sx={{ color: "text.danger", pt: 2, fontSize: '1.6rem' }}>
                    {t('title.needYou')}
                </Typography>
            </Grid>

            <Grid item xs={12} md={6} >

                <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: 600, margin: "auto" }}>
                    <Typography gutterBottom style={{ fontWeight: "bold", marginBottom: 16, fontSize: '1.5rem' }}>
                        {t('title.joinSecuritasFamily')}
                    </Typography>

                    {/* Validation Summary */}
                    {/*Object.keys(errors).length > 0 && (
                        <div style={{ backgroundColor: "#ffe6e6", padding: 10, borderRadius: 4, marginBottom: 16 }}>
                            <Typography variant="caption" color="error" >
                                {t('error.pleaseFixErrorsBelow')}
                            </Typography>
                            <ul style={{ color: "red", paddingLeft: 20 }} >
                                {Object.values(errors).map((error, index) => (
                                    <li key={index}>{error.message}</li>
                                ))}
                            </ul>
                        </div>
                    )*/}
                    <Grid container spacing={2}>
                        {fields.map(({ name, label, type, disabled, required }) => (
                            <Grid item xs={12} sm={6} key={name}>
                                {type == 'date' ?
                                    <CustomDateField
                                        name={name}
                                        label={label}
                                        control={control}
                                        errors={errors}
                                        required={required}
                                    />
                                    :
                                    <CustomTextField
                                        name={name}
                                        label={label}
                                        type={type}
                                        register={register} // Only pass register function
                                        errors={errors}
                                        disabled={disabled}
                                        required={required}
                                    />
                                }
                            </Grid>
                        ))}

                    </Grid>

                    <CustomRadioGroup control={control} errors={errors} />

                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ marginTop: 16 }}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? <CircularProgress size={24} /> : t('button.continue')}
                    </Button>
                    <Typography variant="caption" display="block" align="center" style={{ marginTop: 8 }}>
                        {t('title.requiredFieldNote')}
                    </Typography>
                </form>

            </Grid>
        </Grid>

    </AdayContainer>

}

export default AdayKimlikBilgisi;   